import { Box, Paper, PaperProps, Tab, Tabs, Typography } from '@mui/material';
import { FC, MouseEventHandler, useMemo, useState } from 'react';
import { Dict } from '@ajorquera/libs/utils';

export interface Props extends PaperProps {
  tabs: { label: string; items: Dict[] }[];
  component: FC<{ loading?: boolean; onClick?: MouseEventHandler<HTMLDivElement> }>;
  loading?: boolean;
  onClickItem?: (item: Dict) => void;
}

const TabList: FC<Props> = ({ tabs, loading, component: Component, onClickItem }) => {
  const [tabValue, setTabValue] = useState(0);

  const items = useMemo(() => tabs[tabValue].items, [tabs, tabValue]);

  return (
    <Paper>
      <Tabs sx={{ borderBottom: '.5px solid gray' }} value={tabValue}>
        {tabs?.map((tabItem, i) => (
          <Tab key={i} label={tabItem.label} onClick={() => setTabValue(i)} />
        ))}
      </Tabs>

      <Box display="flex" flexDirection="column" p={3} gap={2}>
        {loading && [1, 2, 3].map((_, i) => <Component key={i} loading />)}

        {!loading && items?.map((item, i) => <Component key={i} {...item} onClick={() => onClickItem?.(item)} />)}
        {!loading && !items.length && (
          <Typography color="textSecondary" p={2}>
            Not available....
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default TabList;
